(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_featured-pages-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('featured-pages-carousel')) {
    class FeaturedPagesCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.nav = this.querySelector('[data-nav]');
        if (!this.track || !this.nav) return;

        this.prevButton = this.nav.querySelector('[data-prev]');
        this.nextButton = this.nav.querySelector('[data-next]');
        this.dotsContainer = this.nav.querySelector('[data-dots]');

        this.prevButton.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton.addEventListener('click', () => this.goTo(this.index + 1));
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
        this.measure();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      /** Width of one card plus the gap after it */
      get step() {
        const first = this.track.firstElementChild;
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      get maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      measure() {
        const step = this.step;
        const canScroll = step > 0 && this.maxScroll > 1;

        this.nav.hidden = !canScroll;
        if (!canScroll) return;

        const maxIndex = Math.round(this.maxScroll / step);
        if (maxIndex !== this.maxIndex) {
          this.maxIndex = maxIndex;
          this.renderDots();
        }
        this.onScroll();
      }

      renderDots() {
        if (!this.dotsContainer) return;

        const total = this.maxIndex + 1;
        const label = this.dotsContainer.dataset.dotLabel || '';
        this.dotsContainer.replaceChildren();

        for (let i = 0; i < total; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'featured-pages__dot';
          dot.setAttribute('aria-label', label.replace('[index]', i + 1).replace('[length]', total));
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsContainer.appendChild(dot);
        }
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.maxIndex));
        this.track.scrollTo({ left: Math.min(clamped * this.step, this.maxScroll) });
      }

      onScroll() {
        const { scrollLeft } = this.track;
        this.index = scrollLeft >= this.maxScroll - 2 ? this.maxIndex : Math.round(scrollLeft / this.step);

        this.prevButton.disabled = this.index <= 0;
        this.nextButton.disabled = this.index >= this.maxIndex;

        this.dotsContainer?.querySelectorAll('.featured-pages__dot').forEach((dot, i) => {
          dot.classList.toggle('active', i === this.index);
          dot.toggleAttribute('aria-current', i === this.index);
        });
      }
    }

    customElements.define('featured-pages-carousel', FeaturedPagesCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
